/** Chat Icon with badge */
import { Chat } from '@tunasong/icons'
import type { IconProps } from '@tunasong/icons'
import type { FC } from 'react'

interface ChatBadgeProps extends IconProps {
  showBadge?: boolean
  numComments: number
}
export const ChatBadge: FC<ChatBadgeProps> = ({ showBadge = true, numComments = 0, ...restProps }) =>
  showBadge ? (
    <span style={{ position: 'relative', display: 'inline-flex' }}>
      <Chat {...restProps} />
      {numComments > 0 && (
        <span
          style={{
            position: 'absolute',
            top: -4,
            right: -4,
            minWidth: 16,
            height: 16,
            borderRadius: 8,
            backgroundColor: 'var(--tuna-palette-secondary-main)',
            color: 'var(--tuna-palette-secondary-contrastText)',
            fontSize: 10,
            fontWeight: 600,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '0 4px',
            lineHeight: 1,
          }}
        >
          {numComments}
        </span>
      )}
    </span>
  ) : (
    <Chat {...restProps} />
  )
